define(
    '../core/Transport.js',[
        'config',
        'loader',
        '../core/Storage.js'
    ],
    function(Config, Loader, Storage)
    {

        var $ = Loader.$;
        var _ = Loader._;
        var _socket = {};

        $.jsonRPC.setup({
            endPoint: document.location.protocol + "//" + window['coreProjectHost'] + Config.transport.rpcPort
        });

        var _ioInitialize = function()
        {
            var options = {
                'reconnectionDelay':  5000,
                'reconnectionAttempts': 50,
                'timeout': 10000,
                //'sync disconnect on unload':    false,
                'transports': ['websocket'],
                'reconnection': true,
                'noFirsteconnect': true
            };

            if (Config.transport.io.enabled) {
                try {
                    var ioHost = 'https://' + Config.transport.io.host;
                    _socket = io.connect(ioHost + Config.transport.io.appChannel, options);
                } catch (e){}
            }
        };

        /**
         * Subscribe on Socket.IO channel
         */
        var _ioSubscribe = function(channel, callback) {
            try {
                _socket.on(channel, callback);
            } catch(e){}
        };

        /**
         * Send data to server
         */
        var _ioSend = function(channel, data) {
            try{
                _socket.send(JSON.stringify({
                    name: channel,
                    data: data
                }));
            } catch(e){}
        };

        var _ioReconnect = function(callback) {
            try {
                _.isFunction(callback) && _socket.on('reconnect', callback);
            } catch(e){}
        };

        /**
         * Send data to server
         */
        var _send = function(channel, data, successCallback, errorCallback, silent)
        {
            if (typeof silent == 'undefined') silent = false;

            var key = channel + ':' + JSON.stringify(data);

            var sendData = _.extend({
                check: {
                    board_id: window['BoardID'],
                    user_id: window['UserID'] || 1,
                    partner_id: window['PartnerID'],
                    group_id: window['GroupID'],
                    user_login: window['UserLogin'] || '',
                    user_lastvisit: window['UserLastVisit'] || '',
                    user_avatar: window['UserAvatar'] || '',
                    host: document.domain,
                    sign: window['ForumAPITicket']
                }
            }, data);

            !silent && Storage.get(key) && successCallback(Storage.get(key));

            console.log('App json-rpc request: ['+channel+'] ', sendData);
            var startTime = (new Date()).getTime();

            $.jsonRPC.request(channel, {
                params: sendData,
                success: function(result) {
                    var time = (new Date()).getTime() - startTime;
                    console.log('App json-rpc response: ['+channel+'] ('+((time/1000) + 's')+') ', result.result);
                    !silent && Storage.set(key, result.result);
                    if (!silent || result.result != Storage.get(key)){
                        _.isFunction(successCallback) && successCallback(result.result);
                    }
                },
                error: function(result) {
                    var time = (new Date()).getTime() - startTime;
                    Storage.remove(key);
                    console.log('App json-rpc error: ['+channel+'] ('+((time/1000) + 's')+') ', result.error);
                    _.isFunction(errorCallback) && errorCallback(result.error);
                }
            });
        };

        return {
            send: _send,
            io: {
                initialize: _ioInitialize,
                send: _ioSend,
                subscribe: _ioSubscribe,
                reconnect: _ioReconnect
            }
        };
    }
);

